import { useEffect, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateFullName } from "../../redux/ApiSlice/AccountSettingSlice";
import { AccountProfile } from "../../redux/ApiSlice/AccountProfileSlice";

const AccountEditDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const { fullNameLoading, fullNameError } = useSelector((state) => state.AccountSetting);

    const [fullName, setFullName] = useState(User_profile?.full_name || "");
    const [localError, setLocalError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    useEffect(() => {
        setFullName(User_profile?.full_name || "");
    }, [User_profile?.full_name]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLocalError("");
        setSuccessMessage("");

        const trimmedName = fullName.trim();
        if (!trimmedName) {
            setLocalError("Please enter your full name.");
            return;
        }

        try {
            await dispatch(updateFullName({ full_name: trimmedName })).unwrap();
            setSuccessMessage("Full name updated successfully.");
            dispatch(AccountProfile());
        } catch (error) {
            const message =
                error?.detail ||
                error?.message ||
                (typeof error === "string" ? error : "Failed to update your name.");
            setLocalError(message);
        }
    };

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate("/settings/account/details")}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Personal Details</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="px-3 flex flex-col justify-between h-[calc(80vh-60px)]">
                <div className="flex flex-col pt-5">
                    <p className="text-[14px] text-black dark:text-white font-bold">Name</p>
                    <p className="text-[12px] text-justify text-black dark:text-white pt-1">
                        This is the name displayed across Chaa Chingg and how others will recognize you.
                        You can update how your name appears at any time here.
                    </p>

                    <div className="mt-5 border-2 border-[#BDE6FF] dark:border-gray-800/50 rounded-lg px-5 py-4">
                        <p className="text-[12px] text-black dark:text-white font-bold">Full Name</p>
                        <input
                            type="text"
                            value={fullName}
                            onChange={(event) => setFullName(event.target.value)}
                            className="w-full text-[12px] bg-white dark:bg-[#1E1D21] text-black dark:text-white outline-none"
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    {(localError || fullNameError) && (
                        <p className="text-[12px] text-red-600">{localError || fullNameError}</p>
                    )}
                    {successMessage && !localError && !fullNameError && (
                        <p className="text-[12px] text-green-600">{successMessage}</p>
                    )}
                    <button
                        type="submit"
                        disabled={fullNameLoading}
                        className="text-[13px] w-full bg-[#BDE6FF] text-black font-bold py-3 rounded-lg disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        {fullNameLoading ? "Saving..." : "Save Changes"}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AccountEditDetails